module.exports = __webpack_public_path__ + "static/awards-icon-5-99c0008ac955a435d7d38aa6580b2a71.png";